<template>
    <div class="hero hero-banner">
        <LazyLoadedImage class="hero-banner__image" :src="imgSrc" alt="Hero Banner"></LazyLoadedImage>
        <div class="hero-banner__dots"></div>
        <div class="hero-body hero-banner__content">

            <div class="container has-text-centered hyphenate">
                <div class="title has-text-light is-size-4 pt-6 mb-6">{{title}}</div>
                <div class="subtitle has-text-light is-uppercase is-size-4 is-size-2-desktop">{{subtitle}}</div>
                <div class="has-text-light is-size-4 is-size-4-desktop mb-6" v-html="bodytext"></div>
                <RouterLink v-if="link !==''" class="button is-primary-dark hero-banner__button" :to="link">
                <span>
                    Mehr erfahren
                </span>
                    <SvgIcon icon="icon--directional_arrow-right" class="is-light"/>
                </RouterLink>
            </div>
        </div>
    </div>
</template>

<script>
    import LazyLoadedImage from "../shared/LazyLoadedImage";
    import SvgIcon from "../svg/SvgIcon";

    export default {
        name: "HeroBanner",
        components: {LazyLoadedImage, SvgIcon},
        data() {
            return {}
        },

        props: {
            contentData: {
                type: Object,
                required: true
            }
        },
        computed: {
            imgSrc() {
                return this.contentData.content.gallery.rows[1].columns[1].publicUrl
            },
            title() {
                return this.contentData.content.header;
            },
            subtitle() {
                return this.contentData.content.subheader;
            },
            bodytext() {
                return this.contentData.content.bodytext.replace(/(?:\r\n|\r|\n)/g, '<br>');
            },
            link() {
                return this.contentData.content.headerLink.url || '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .hero-banner {
        position: relative;
        overflow: hidden;
        text-align: center;

        &__dots {
            position: absolute;
            background: radial-gradient($primary-light, 1px, transparentize($primary-light, 1) 1px);
            background-size: 10px 10px;
            height: 100%;
            width: 100%;
            z-index: $z-index-hero-content - 1;
        }

        &__image {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        &__content {
            z-index: $z-index-hero-content;
        }


        &:before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: transparentize($grey, 0.2);
            z-index: $z-index-hero-content - 2;
        }

        &__button {
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            min-width: 250px;
        }

    }

</style>